import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const MyPurchases = () => (
  <Box sx={{ backgroundColor: 'secondary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">itau - /app/purchases/payable/my-purchases</Typography>
  </Box>
);

export default MyPurchases;
